<template>
  <div class="container" style="">
    <div class="mx-auto" style="width: 400px">
      <b-card header-tag="header">
        <h6 slot="header" class="mb-0">
          <img src="../assets/logo.png" style="width: 75px; height: 40px" />
        </h6>
        {{ info }}
        <div
          style="color: #333; text-align: center; padding: 10px 15px"
          v-on:keyup.enter="login"
          v-on:keyup="keymonitor"
        >
          <p id="text" v-if="this.caps == true" style="font-weight: bold">
            Caps lock is ON.
          </p>
          <vue-form-generator
            :schema="schema"
            :model="credentials"
            :options="formOptions"
          ></vue-form-generator>
          <b-btn variant="primary btn-block" size="sm" @click="login"
            >Login</b-btn
          >
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",

  data() {
    return {
      info: null,
      caps: false,
      credentials: {
        username: "",
        password: "",
      },

      schema: {
        fields: [
          {
            type: "input",
            inputType: "text",
            label: "Username",
            id: "username",
            model: "username",
            required: true,
            validator: "string",
            attributes: {
              autofocus: true,
            },
          },
          {
            type: "input",
            inputType: "password",
            label: "Password",
            id: "password",
            model: "password",
            required: true,
            validator: "string",
          },
        ],
      },
      formOptions: {
        validateAfterChanged: true,
        validateAsync: true,
      },
    };
  },
  methods: {
    keymonitor: function (event) {
      if (event.key != undefined) {
        if (event.getModifierState("CapsLock")) {
          this.caps = true;
        } else {
          this.caps = false;
        }
      }
    },

    login: async function () {
      if (this.credentials.username && this.credentials.password) {
        var res = await this.$api.auth.login(this.credentials);
        try {
          //console.log("res: ", res);
          document.getElementById("ithUserID").value = res.id;
        }
        catch(err) { }
      }
    },
  },

  mounted() {},
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue